export const POOLED_PLAN_TYPES: string[] = ['mep', 'gop', 'pep'];

export const POOLED_PLAN_SUBTYPES = [
  'Closed-PEOs',
  'Closed-Associations or Franchises',
  'Closed-Closely Held Businesses',
  'Closed-Other Organizations'
];
